import { render, staticRenderFns } from "./activity-project.vue?vue&type=template&id=4023e2c6&scoped=true&"
import script from "./activity-project.vue?vue&type=script&lang=js&"
export * from "./activity-project.vue?vue&type=script&lang=js&"
import style0 from "./activity-project.vue?vue&type=style&index=0&id=4023e2c6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4023e2c6",
  null
  
)

export default component.exports